'use strict';

angular.module('clientDashboardApp').controller("ListingOptimizationCtrl",
    function ($scope, $log, $timeout, listingService, searchService, reactContainer) {

        $scope.noteSettings = {type: "Listings", userInfo: $scope.userInfo}
        $scope.columns = reactContainer.getContainer().columns;

        $scope.listingMatchConfig.onLocationUpdate = (location) => {
          const copy = angular.copy($scope.searchResults.results)
          delete $scope.searchResults.results  /* force the listing-match directive to render new data */
          $scope.searchResults.results = $scope.listingsWithUpdatedLocations(copy, location)
        }

        $scope.providerSummaryOptions = {sortField: 'count', reverseSortOrder: true};
        $scope.providerSummarySortIcon = function (column) {
            if ($scope.providerSummaryOptions.sortField === column) {
                if ($scope.providerSummaryOptions.reverseSortOrder) {
                    return 'fa-sort-up';
                } else {
                    return 'fa-sort-down';
                }
            } else {
                return 'fa-sort';
            }
        };

        $scope.listingMatchConfig.refresh = () => (listingService.forceListingLocationRefresh($scope))

        $scope.sortProviderSummaryTable = function (sortColumn) {
            if ($scope.providerSummaryOptions.sortField === sortColumn) {
                $scope.providerSummaryOptions.reverseSortOrder = !$scope.providerSummaryOptions.reverseSortOrder;
            } else {
                $scope.providerSummaryOptions.sortField = sortColumn;
                $scope.providerSummaryOptions.reverseSortOrder = false;
            }
        };

        var updateResults = function (searchResults) {
          for (var i = 0; i < searchResults.results.length; i++) {
            var locationId = searchResults.results[i].locationId;
            if (searchResults.results[i].description == "null") {
              searchResults.results[i].description = null;
            }
            $scope.locationSummary(locationId);
          }
          $scope.searchResults = searchResults;

          $scope.listingLocationsLoaded = false

          $scope.listingsWithLocations($scope.searchResults.results).then(withLocations => {
            $scope.searchResults.results = withLocations

            $scope.drillDownResults = true;
            $scope.loadingListingResults = false
            $scope.listingLocationsLoaded = true
          })

        };

        $scope.selectedCell = {};
        $scope.isSelected = function (provider, column) {
            return $scope.selectedCell.column === column && $scope.selectedCell.provider === provider;
        };

        $scope.drillDownOptions = { limit:10, reportType: reactContainer.getContainer().reportType };
        $scope.selectCell = function (provider, column) {
            $scope.loadingListingResults = true;
            var newSelection = {column: column, provider: provider};
            $scope.selectedCell = newSelection;

            var reportOptions = {};
            reportOptions.providers = newSelection.provider;
            reportOptions.column = newSelection.column;

            //Combine with drill down
            angular.extend($scope.drillDownOptions, $scope.reportOptions, reportOptions);
            listingService.listingReportDrillDown($scope.drillDownOptions.reportType, $scope.drillDownOptions.groupId, $scope.drillDownOptions, updateResults);
        };

        var exportFilter = {
          groupId: $scope.searchConfig.groupId
        };
        if ($scope.searchConfig.providers) {
          exportFilter.providers = $scope.searchConfig.providers.join();
        }

        $scope.exportAllResults = searchService.withExportConfig("listings",exportFilter);

    });
